<template>
  <div id="search" class="search-container">
    <b-form-input
      size="lg"
      id="input_search"
      type="search"
      placeholder="ค้นหาคอร์สเรียน"
      v-model="searchText"
      class="search_input"
      @keydown.enter.prevent="search"
    />
    <b-icon-search
      class="search-icon"
      @click="search"
    />
  </div>
</template>

<script>
export default {
  props: ["placeholder"],
  name: "Search",
  data() {
    return {
      searchText: null,
    };
  },
  methods: {
    search() {
      this.$emit("search", this.searchText);
    },
  },
};
</script>

<style scoped>
.search-container {
  position: relative;
  margin: 1rem 0;
}

.search_input {
  width: 400px;
  /* width: 100%; */
  padding-right: 2.5rem; /* space for icon */
  border-radius: 10px;
  color: #0F3051 !important;
  border-color: #0F3051 !important;
}

 

.search-icon {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  color: #0F3051;
  cursor: pointer;
  font-size: 1.25rem;
}
</style>
